import { FC, SVGProps } from 'react';

export const MobileApp: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="5" y="2" width="14" height="20" rx="3" stroke={props.stroke || '#0851FE'} strokeWidth="1.2" strokeLinejoin="round" />
    <path d="M11 19H13" stroke={props.stroke || '#0851FE'} strokeWidth="1.2" strokeLinecap="round" />
  </svg>
);
